import { useQuery } from '@tanstack/react-query';
const useAdaptedWalletBalance = ({ wallet, chain, address, currency, enabled = true, refreshInterval = 60000 }) => {
    const queryKey = [
        'adaptedWalletBalance',
        wallet?.vmType,
        chain?.id,
        address,
        currency
    ];
    const query = useQuery({
        queryKey,
        queryFn: async () => {
            if (!wallet?.getBalance || !chain?.id || !address)
                return undefined;
            return wallet.getBalance(chain.id, address, currency);
        },
        enabled: Boolean(wallet?.getBalance && enabled && chain?.id && address),
        refetchInterval: refreshInterval
    });
    return {
        ...query,
        queryKey
    };
};
export default useAdaptedWalletBalance;
//# sourceMappingURL=useAdaptedWalletBalance.js.map